<!-- Return of each purchase over successive horizons (heatmap). -->
<script lang="ts">
  import * as E from "../../core/engine";
  import type { PurchaseRow } from "../../core/types";
  import { fmtDate, fmtNum, fmtQty, heat, pctPlain } from "../../lib/format";
  import Money from "../../components/Money.svelte";
  import Pct from "../../components/Pct.svelte";
  let { list, withName = true }: { list: readonly PurchaseRow[]; withName?: boolean } = $props();
  const sorted = $derived([...list].sort((a, b) => (a.day < b.day ? 1 : -1)));
  const H = E.HORIZONS;
</script>

<div class="table-wrap"><table class="heat"><thead><tr><th class="l">Data zakupu</th>{#if withName}<th class="l">Instrument</th>{/if}<th class="l">Rachunek</th><th>Ilość</th><th>Cena</th><th>Koszt</th>
  {#each H as h (h.k)}<th>{h.k}</th>{/each}<th>Dziś</th><th>Rocznie</th></tr></thead>
  <tbody>
    {#each sorted as x, i (i)}
      <tr><td class="l">{fmtDate(x.day)}</td>{#if withName}<td class="l">{x.name} <span class="muted small">{x.symbol}</span></td>{/if}<td class="l">{x.account}</td>
        <td>{fmtQty(x.qty)}</td><td>{fmtNum(x.price, 3)} {x.priceCcy}</td><td><Money v={x.costPLN} /></td>
        {#each H as h (h.k)}<td class="cell" style={heat(x.hz[h.k])}>{#if x.hz[h.k] === null}<span class="muted">·</span>{:else}{pctPlain(x.hz[h.k])}{/if}</td>{/each}
        <td class="cell" style={heat(x.retNow, 0.5)}><b>{pctPlain(x.retNow)}</b></td><td><Pct v={x.annNow} /></td></tr>
    {/each}
  </tbody>
</table></div>
